import Vue from 'vue'
import VueI18n from 'vue-i18n'

Vue.use(VueI18n)

const messages = {

  pt: {
    cursos: 'Cursos',
    simulados: 'Simulados',
    artigos: 'Artigos',
    categorias: 'Categorias',
    sistemas: 'Sistemas',
    disciplinas: 'Disciplinas',
    irParaCursoLink: 'Ir para o curso',
    videos: 'Videos',
    horas: 'Horas',
    ebooksArtigos: 'e-books / artigos',
    ementa: 'Ementa',
    professores: 'Professores',
    placeholder: {
      pesquisacurso: 'Busque pelo curso desejado',
      pesquisasimulado: 'Busque pelo simulado desejado'
    },
    perfil: {
      meusdados: 'Meus dados',
      dadosacesso: 'Dados de acesso',
      dadospessoais: 'Dados pessoais',
      dadosacademicos: 'Dados acadêmicos'
    },
    btn: {
      editar: 'Editar'
    }
  },
  en: {
    cursos: 'Courses',
    simulados: 'Tests',
    artigos: 'Articles',
    categorias: 'Categories',
    sistemas: 'Systems',
    disciplinas: 'Subjects',
    irParaCursoLink: 'Go to the course',
    videos: 'Videos',
    horas: 'Hours',
    ebooksArtigos: 'ebooks / articles',
    ementa: 'Course Program',
    professores: 'Teachers',
    placeholder: {
      pesquisacurso: 'Search for the course',
      pesquisasimulado: 'Search for the practice test'
    },
    perfil: {
      meusdados: 'My profile',
      dadosacesso: 'Access data',
      dadospessoais: 'Personal data',
      dadosacademicos: 'Academic data'
    },
    btn: {
      editar: 'Edit'
    }
  }

}

const i18n = new VueI18n({
  locale: 'pt',
  fallbackLocale: 'pt',
  messages
})

export default i18n
